// NGRX
import { createFeatureSelector, createSelector } from '@ngrx/store';
// Lodash
import { each } from 'lodash-es';
// CRUD
import { QueryResultsModel } from '../../_base/crud';
// State
import { PatientsState } from '../_reducers/patient.reducers';
import { PatientModel } from '../_models/patient.model';

export const selectPatientsState = createFeatureSelector<PatientsState>('patients');

export const selectPatientById = (patientId: number) =>
  createSelector(selectPatientsState, (patientsState) => patientsState.entities[patientId]);

export const selectPatientsPageLoading = createSelector(
  selectPatientsState,
  (patientsState) => patientsState.listLoading,
);

export const selectPatientsActionLoading = createSelector(
  selectPatientsState,
  (patientsState) => patientsState.actionsloading,
);

export const selectLastCreatedPatientId = createSelector(
  selectPatientsState,
  (patientsState) => patientsState.lastCreatedPatientId,
);

export const selectLastCreatedPatient = createSelector(
  selectPatientsState,
  (patientsState) => patientsState.lastCreatedPatient,
);

export const selectPatientErrorState = createSelector(
  selectPatientsState,
  (patientsState) => patientsState.error,
);

export const selectPatientLatestSuccessfullAction = createSelector(
  selectPatientsState,
  (patientsState) => patientsState.latestSuccessfullAction,
);

export const selectPatientsShowInitWaitingMessage = createSelector(
  selectPatientsState,
  (patientsState) => patientsState.showInitWaitingMessage,
);

export const selectPatientsInStore = createSelector(selectPatientsState, (patientsState) => {
  const items: PatientModel[] = [];
  each(patientsState.ids, (ele) => {
    const index: number = +ele;
    items.push(patientsState.entities[index]);
  });
  return new QueryResultsModel(items, patientsState.totalCount);
});
